// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>6</span>&nbsp;&nbsp;An offering of a free heart will I give you&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;and praise your name, O Lord, for it is gracious.<br> </p> </div></div>";
// Exports
module.exports = code;